import React from 'react';
import { PropTypes } from 'prop-types';
import Table from '../common/Table/Table';
import {
  LEAD_HEADERS,
  LEAD_VALUES,
  LEAD_VALUES_FOR_DATA_LABELS,
  HOMEPAGE_PIPELINE_HEADERS,
  HOMEPAGE_PIPELINE_VALUES,
  HOMEPAGE_PIPELINE_VALUES_FOR_DATA_LABELS
} from '../../constants/tableHeaders';
import HOME_PAGE from '../../constants/homePage';
import utils from '../../lib/utils';


export class HomePageTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {resultSetRevealed: 1};

    this.loadMore = this.loadMore.bind(this);
    this.renderActionCell = this.renderActionCell.bind(this);
  }

  renderActionCell(rowData) {
    return utils.opportunityActionCellData(rowData);
  }

  // NOTE: The logic below is only designed to work with the following values:
  //
  // ```
  // HOME_PAGE.displaySize = 5
  // HOME_PAGE.pageSize = 15
  // ```
  //
  // In the future it would be nice to allow this component to work with any
  // value for both `displaySize` and `pageSize`. In fact, `pageSize` isn't
  // used, and is simply assumed to be 15 currently. The constant is left in
  // the code because in fixing this issue it will become used.

  loadMore() {
    this.setState({ resultSetRevealed: this.state.resultSetRevealed + 1 });
  }

  determineDataToDisplay() {
    const content = this.props.content;

    let data;
    switch (this.state.resultSetRevealed) {
      case 1:
        data = content.slice(0, 5);
        break;
      case 2:
        data = content.slice(0, 10);
        break;
      case 3:
        data = content.slice(0, 15);
        break;
      default:
        data = content;
    }
    return data;
  }

  tableHeaderInfo() {
    switch (this.props.dataType) {
      case 'lead':
        return {
          headers: LEAD_HEADERS,
          values: LEAD_VALUES,
          dataLabels: LEAD_VALUES_FOR_DATA_LABELS
        };
      case 'pipeline':
        return {
          headers: HOMEPAGE_PIPELINE_HEADERS,
          values: HOMEPAGE_PIPELINE_VALUES,
          dataLabels: HOMEPAGE_PIPELINE_VALUES_FOR_DATA_LABELS
        };
      default:
        throw Error("expected `dataType` to be one of: 'lead', 'pipeline'");
    }
  }

  renderInfoMessage() {
    const moreInfoMessage = this.props.moreInfoMessage;
    return (
      <div className="latest-content__info-message-wrap">
        <div className="latest-content__info-message">
          <div className="latest-content__message-content">
            {moreInfoMessage}
          </div>
        </div>
      </div>
    );
  }

  renderTable(dataToDisplay) {
    const { headers, values, dataLabels } = this.tableHeaderInfo();
    const loadMoreVisible = this.props.content.length / HOME_PAGE.displaySize > this.state.resultSetRevealed;
    return (
      <span>
      <Table
        headers={headers}
        values={values}
        tableData={dataToDisplay}
        dataLabels={dataLabels}
        searchError={this.props.contentError}
        useSortArrows={false}
        useTablePaginator={false}
        useLoadMore={true}
        loadMoreVisible={loadMoreVisible}
        loadMore={this.loadMore}
        renderActionCell={this.renderActionCell}
        isAdmin={this.props.isAdmin}
        noDataMessage={this.props.noDataMessage}
        />
        {/* if there is no load more button render the message*/}
        {!loadMoreVisible && this.renderInfoMessage()}
      </span>
    );
  }

  renderContent(dataToDisplay) {
    return (
      <span className="latest-content__title-table-wrap">
        <h3 className="latest-content__title title is-5">
          {this.props.title}
        </h3>
        {this.renderTable(dataToDisplay)}
      </span>
    );
  }

  render() {
    const dataToDisplay = this.determineDataToDisplay();
    return (
      <div className="latest-content-container page page-font-scale">
        <div className="latest-content-container__inner-wrap">
          {this.renderContent(dataToDisplay)}
        </div>
      </div>
    );
  }
}



HomePageTable.propTypes = {
  content: PropTypes.array.isRequired,
  contentError: PropTypes.bool.isRequired,
  dataType: PropTypes.string.isRequired,
  isAdmin: PropTypes.bool,
  moreInfoMessage: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  noDataMessage: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

HomePageTable.defaultProps = {
  moreInfoMessage: null
};


export default HomePageTable;
